import React from 'react'
import { Channel, Window, MessageList, MessageInput } from 'stream-chat-react'
import { withStreamClient } from 'lib/stream-messaging'
import { useFeatureFlags, flags } from 'lib/feature-flags'
import HideFileUploadButton from './hide-file-upload-button'

const ChannelEmbed = withStreamClient(({ channel }) => {
  const [allowAttachments] = useFeatureFlags([
    flags.FLAG_FEAT_MESSAGING_ATTACHMENTS,
  ])
  return (
    <Channel channel={channel}>
      <Window>
        <MessageList />
        <MessageInput />
        {!allowAttachments && <HideFileUploadButton />}
      </Window>
    </Channel>
  )
})

const WrappedChannelEmbed = ({ channel }) => (
  <div className="str-chat-embed">
    <ChannelEmbed channel={channel} />
  </div>
)

export default WrappedChannelEmbed
